import { Component, OnInit } from "@angular/core";
import { LoggerService } from "src/shared/logger/logger.service";
import { Levels } from 'src/shared/logger/levels.enum';
import { endpoint } from "../../shared/endpoints.model";
import { SystemProfileService } from 'src/system-profile-manager/shared/system-profile-V2.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmationComponent } from "src/shared/Dialogs/dialog-confirmation/dialog.confirmation.component";

@Component({
  selector: 'system-setting-component',
  templateUrl: './system-setting.component.html',
  styleUrls: ['./system-setting.component.css']
})

export class SystemSettingComponent implements OnInit {

  endpoint_data: endpoint;
  endpoint_warnings: string[] = [];
  panelOpenState1 = false;
  panelOpenState2 = false;
  panelOpenState3 = false;
  panelOpenState4 = false;
  panelOpenState5 = false;
  pullSystemFlag: boolean = false;
  deleteSystemFlag: boolean = false;
  adminAuthorization: boolean;

  constructor(private loggerService: LoggerService,
    private systemService: SystemProfileService,
    private _snackBar: MatSnackBar, public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.adminAuthorization = this.systemService.adminAuthorization

    this.systemService.endpointDateToBeTransmitted.subscribe(data => {
      this.endpoint_data = data

      this.endpoint_warnings = [];
      if (this.endpoint_data?.system_password !== 1) this.endpoint_warnings.push("This system does not have a password.")
      if (this.endpoint_data?.is_provisioned !== 1) this.endpoint_warnings.push("This system is not provisioned by VMS.")

    });
  }

  openDialog(): void {
    if (this.deleteSystemFlag) {
      return;
    }
    let systemToBeDeleted = { id: this.endpoint_data.id, name: this.endpoint_data.system_name, ip: this.endpoint_data.system_ip }
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Delete system", message: `Are you sure you want to delete system with name = ${systemToBeDeleted.name} and ip = ${systemToBeDeleted.ip}.` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteSystem(systemToBeDeleted);
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  pullDataFromSystem() {
    if (this.pullSystemFlag) {
      return;
    }
    if (this.endpoint_warnings.length > 0) {
      this.openSnackBar("You cannot pull the system profile before solving all the warnings shown in red.", "Error");
      return;
    }
    this.pullSystemFlag = true;
    this.systemService.pullFromSystem(this.endpoint_data.system_ip).subscribe(data => {
      this.pullSystemFlag = false;
      this.endpoint_data = data["message"];
      this.endpoint_data.enable_phonebook = this.endpoint_data.enable_phonebook == '1' ? "On" : "Off"
      this.endpoint_data.enable_sip = this.endpoint_data.enable_sip == '1' ? "On" : "Off"
      this.endpoint_data.enable_h323 = this.endpoint_data.enable_h323 == '1' ? "On" : "Off"
      this.systemService.endpointDateToBeTransmitted.next(this.endpoint_data);
      this.loggerService.log("SystemSettingComponent", `Data were pulled for unit with id =${data.id}`, Levels.info)
      this.openSnackBar('Data pull is completed', "Success");
    }, err => {
      this.loggerService.log("SystemSettingComponent", err.message, Levels.error)
      this.openSnackBar('Connection error occurred while pulling data', "Error");
      this.pullSystemFlag = false;
    })
  }

  deleteSystem(systemToBeDeleted) {
    this.deleteSystemFlag = true;
    this.systemService.deleteSystem(systemToBeDeleted.ip).subscribe(res => {
      this.deleteSystemFlag = false;
      this.systemService.endpointDateToBeTransmitted.next(null);
      this.loggerService.log("SystemSettingComponent", `System was deleted with id = ${systemToBeDeleted.id} , name = ${systemToBeDeleted.name} and ip = ${systemToBeDeleted.ip}.`, Levels.warning)
      this.openSnackBar('System deleted is done', "Success");
    }, err => {
      this.deleteSystemFlag = false;
      this.loggerService.log("SystemSettingComponent", `System with id = ${systemToBeDeleted.id} could not be deleted`, Levels.error)
      this.loggerService.log("SystemSettingComponent", err.message, Levels.error)
      this.openSnackBar('Could not reach system but was deleted successfully', "Error");
    })
  }

}
